import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import CategoryPage from '@/pages/category/page';
import MangaDetailPage from '@/pages/manga/page';
import ReadPage from '@/pages/read/page';
import AboutPage from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/category', element: <CategoryPage /> },
      { path: '/category/:slug', element: <CategoryPage /> },
      { path: '/manga/:id', element: <MangaDetailPage /> },
      { path: '/read/:mangaId/:chapterId', element: <ReadPage /> },
      { path: '/about', element: <AboutPage /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;